import React from "react";
import styles from "./StandardScreen.module.css";

export default function StandardScreen({
  topNav = null,
  children,
  bottomAction = null,
  isLoading = false,
  loadingState = null,
  isEmpty = false,
  emptyState = null,
  isError = false,
  errorState = null,
  className = "",
  contentClassName = "",
  background = "default", // "default" | "surface"
}) {
  var hasBottomAction = Boolean(bottomAction);

  var bodyContent = children;

  if (isLoading) {
    bodyContent = loadingState || (
      <div className={styles.state}>Loading...</div>
    );
  } else if (isError) {
    bodyContent = errorState || (
      <div className={styles.state}>Something went wrong.</div>
    );
  } else if (isEmpty) {
    bodyContent = emptyState || (
      <div className={styles.state}>Nothing to show yet.</div>
    );
  }

  return (
    <div
      className={[
        styles.screen,
        background === "surface"
          ? styles.surfaceBackground
          : styles.defaultBackground,
        className,
      ].join(" ")}
    >
      {topNav ? <div className={styles.topNavSlot}>{topNav}</div> : null}

      <div
        className={[
          styles.body,
          hasBottomAction ? styles.withBottomAction : "",
        ].join(" ")}
      >
        <div className={[styles.content, contentClassName].join(" ")}>
          {bodyContent}
        </div>
      </div>

      {hasBottomAction ? (
        <div className={styles.bottomActionOverlay}>
          <div className={styles.bottomActionBar}>
            <div className={styles.bottomActionInner}>{bottomAction}</div>
          </div>
        </div>
      ) : null}


    </div>
  );
}

export function ScreenContent({ children, className = "" }) {
  return <div className={[styles.contentStack, className].join(" ")}>{children}</div>;
}

export function ScreenSection({
  children,
  className = "",
  spacing = "default",
}) {
  return (
    <section
      className={[
        styles.section,
        className,
      ].join(" ")}
    >
      {children}
    </section>
  );
}

export function ScreenBottomAction({ children, className = "" }) {
  return (
    <div className={[styles.bottomActionBar, className].join(" ")}>
      <div className={styles.bottomActionInner}>{children}</div>
    </div>
  );
}